// src/js/ga.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fires a GA4 page_view on every route change.
 * Relies on global gtag() from the SSR snippet in App.js.
 * (Must be rendered inside <BrowserRouter> so that useLocation() works.)
 */
export function PageViewTracker() {
    const location = useLocation();

    useEffect(() => {
        if (typeof window.gtag !== 'function') return;

        // Compose page_path without query params (adjust as needed)
        const path = location.pathname + location.search;
        window.gtag('event', 'page_view', {
            page_path: path,
            page_title: document.title, // optional: pulls from <title> in <head>
        });
    }, [location]);

    // No UI to render, just fires GA events
    return null;
}
